export function validateFirstName(firstNameValue, errors) {
  if (firstNameValue === '') {
    errors["firstName"] = "Please fill in your first name";
  } else if (typeof firstNameValue !== "undefined") {
    if (!firstNameValue.match(/^[a-zA-Z ]{2,17}$/)) {
      errors["firstName"] = "Please enter a valid name, avoid numbers and special characters";
    } else {
      delete errors.firstName;
    }
  }
}
export function validateLastName(lastNameValue, errors) {
  if (lastNameValue === '') {
    errors["lastName"] = "Please fill in your last name";
  } else if (typeof lastNameValue !== "undefined") {
    if (!lastNameValue.match(/^[a-zA-Z ]{2,17}$/)) {
      errors["lastName"] = "Please enter a valid name, avoid numbers and special characters";
    } else {
      delete errors.lastName;
    }
  }
}
export function validateAddressLine1(addressValue, errors) {
  if (addressValue === '') {
    errors["addressLine1"] = "Please enter a valid street address";
  } else if (!addressValue.match(/^[a-zA-Z0-9.\/#'":_ -]{1,35}$/)) {
    errors["addressLine1"] = "Please enter a valid street address";
  } else {
    delete errors.addressLine1;
  }
}
export function validateAddressLine2(addressLine2Value, errors) {
  if (addressLine2Value === '') {
    if (errors.addressLine2) {
      delete errors.addressLine2;
    }
  } else if (!addressLine2Value.match(/^[\w\-\.\ ]{1,35}$/)) {
    errors["addressLine2"] = "Please enter a valid Apartment/Suite/Building name or number";
  } else {
    delete errors.addressLine2;
  }
}
export function validateCity(city, errors) {
  if (city === '') {
    errors["city"] = "Please enter a valid city";
  } else if (typeof city !== "undefined") {
    if (!city.match(/^[a-zA-Z ]{2,30}$/)) {
      errors["city"] = "Please enter a valid city, avoid numbers and special characters";
    } else {
      delete errors.city;
    }
  }
}
export function validateState(state, errors) {
  if (state === '') {
    errors["stateOrProvince"] = "Please select a state";
  } else if (typeof state !== "undefined") {
    if (!state.match(/^[a-zA-Z ]{2,30}$/)) {
      errors["stateOrProvince"] = "Please select a state";
    } else {
      delete errors.stateOrProvince;
    }
  }
}
export function validateZip(zip, errors) {
  if (zip === '') {
    errors["postalCode"] = "Please enter a valid zip code";
  } else if (typeof zip !== "undefined") {
    if (!zip.match(/^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] *\d[A-Z]\d)$/)) {
      errors["postalCode"] = "Please enter a valid zip code";
    } else {
      delete errors.postalCode;
    }
  }
}
export function validatePhone(phoneNumberValue, errors) {
  if (phoneNumberValue === '') {
    errors["phoneNumber"] = "Please fill in your phone number";
  } else if (typeof phoneNumberValue !== "undefined") {
    if (!phoneNumberValue.match(/\d{10}$/)) {
      errors["phoneNumber"] = "Phone number should contain only 10 numbers";
    } else {
      delete errors.phoneNumber;
    }
  }
}